import React, { useState, useContext } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import { Button, Form, FormGroup, Label, Input, Row, Col } from "reactstrap";
import axios from "axios";
import Swal from "sweetalert2";

// onSaved: lo manda el listado para refrescarse sin recargar la página
function EtapasCreate({ onSaved }) {
  const { user } = useContext(AuthContext);
  const URL_CRM_ETAPAS = process.env.REACT_APP_URL_CRM_ETAPAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  const [nombre, setNombre] = useState("");
  const [orden, setOrden] = useState("");
  const [probabilidad, setProbabilidad] = useState(0);
  const [color, setColor] = useState("#6c757d");
  const [tipo, setTipo] = useState("abierta");
  const [validaBoton, setValidaBoton] = useState(true);

  const saveEtapa = (event) => {
    event.preventDefault();
    setValidaBoton(false);
    axios
      .post(
        URL_CRM_ETAPAS,
        { nombre, orden, probabilidad, color, tipo },
        { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
      )
      .then(() => {
        axios.post(
          URL_LOGS,
          { tipo: "Crear Etapa CRM", detalle: nombre, user: user.id },
          { headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` } }
        );
        Swal.fire("Good job!", "Etapa creada con exito", "success");
        if (onSaved) onSaved();
        else setTimeout(() => window.location.reload(), 1000);
      })
      .catch((error) => {
        setValidaBoton(true);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response ? error.response.data : error}`,
        });
      });
  };

  return (
    <Form onSubmit={saveEtapa}>
      <Row>
        <Col md={8}>
          <FormGroup>
            <Label>Nombre de la etapa</Label>
            <Input
              type="text"
              placeholder="Ej. Calificado"
              value={nombre}
              required
              onChange={(e) => setNombre(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Orden</Label>
            <Input
              type="number"
              value={orden}
              required
              onChange={(e) => setOrden(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={4}>
          <FormGroup>
            <Label>Probabilidad (%)</Label>
            <Input
              type="number"
              min="0"
              max="100"
              value={probabilidad}
              onChange={(e) => setProbabilidad(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Color</Label>
            <Input
              type="color"
              value={color}
              onChange={(e) => setColor(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col md={4}>
          <FormGroup>
            <Label>Tipo</Label>
            <Input type="select" value={tipo} onChange={(e) => setTipo(e.target.value)}>
              <option value="abierta">Abierta</option>
              <option value="ganada">Ganada (cierra)</option>
              <option value="perdida">Perdida (cierra)</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>
      <Row className="container">
        <Button type="submit" className="btn btn-success" disabled={!validaBoton}>
          Guardar
        </Button>
      </Row>
    </Form>
  );
}

export default EtapasCreate;
